var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.surveyType,{tag:"component",attrs:{"content":_vm.content},on:{"submit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }